<!--
 * @Author: dengqirui
 * @Date: 2023-08-18 11:21:02
 * @LastEditors: dengqirui dengqr@dreamdt.cn
 * @LastEditTime: 2023-08-21 10:46:58
-->
<template>
  <div class="dsfa-sc-login-popup-detail" v-if="show">
    <div class="detail-head">
      <div class="detail-title" v-if="detail.title">
        {{ detail.title }}
      </div>
      <div class="detail-info" v-if="detail.date || detail.source">
        <span class="detail-info-time"> 时间： {{ detail.date }} </span>
        <span v-if="detail.source" class="detail-info-author">
          来源：{{ detail.source }}
        </span>
      </div>
    </div>
    <div class="detail-content">
      <DsfVirtualScroll>
        <div v-if="detail.content" v-html="detail.content"></div>
        <div class="line" v-if="showLine"></div>
        <div class="file" v-if="detail.fileUpload && detail.fileUpload.length">
          <p v-for="list in detail.fileUpload" :key="list.id">附件：<span :title="list.originalFileName" @click="downLoadFn(list)" class="fj">{{  list.originalFileName }}</span></p>
        </div>
      </DsfVirtualScroll>
    </div>
    <div class="detail-foot">
      <!-- <DsfButton size="small" title="关闭" @click="close()">
        关闭
      </DsfButton> -->
      <div class="detail-btn" @click="close()">关闭</div>
    </div>
    <div class="close" @click="close()">
      <i class="iconfont icon-guanbi2"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupDetail",
  props: {
    showLine: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      show: false,
      detail: {
        content: "",
        date: "",
        source: "",
        title: "",
      },
    };
  },
  watch: {},
  components: {},
  computed: {},
  created() {},
  methods: {
    showDetail(data) {
      this.detail = data;
      this.show = true;
      this.$emit("maskSwitch", true);
    },
    getDetail(id) {
      let loadVm = dsf.layer.loading();
      let params = {
        id: id,
      };
      dsf.http
        .get(`/announce/getDetailById`, params)
        .done(({ data, success, message }) => {
          if (success) {
            this.detail = data;
            this.show = true;
            this.$emit("maskSwitch", true);
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          if (err) {
            dsf.layer.message(err.message || "未知错误", false);
          }
        })
        .always(() => {
          dsf.layer.closeLoading(loadVm);
        });
    },
    close() {
      this.show = false;
      this.$emit("maskSwitch", false);
    },
    downLoadFn(row) {
      dsf.file.download.call(
          this,
          "/file/download",
          {
            files: row.id,
            zipName: row.name
          },
          row.originalFileName,
          true
        );
    }
  },
};
</script>
